import dayjs from 'dayjs';

export const tutorReplacementsTableHeader = [
  { field: 'slNo', headerName: 'Sl No', width: 80 },
  { field: 'tutorName', headerName: 'Tutor Name', width: 200, toolTipGetter: true },
  { field: 'tutorMobile', headerName: 'Mobile No', width: 160 },
  { field: 'studentName', headerName: 'Student Name', width: 200, toolTipGetter: true },
  { field: 'courseName', headerName: 'Course', width: 260, toolTipGetter: true },
  { field: 'subjectName', headerName: 'Subject Name', width: 200, toolTipGetter: true },
  { field: 'croName', headerName: 'CRO Name', width: 180, toolTipGetter: true },
  { field: 'oldTutorName', headerName: 'Old Tutor Name', width: 200, toolTipGetter: true },
  { field: 'oldTutorMobile', headerName: 'Old Tutor Mobile', width: 170 },
  { field: 'oldTutorEmail', headerName: 'Old Tutor Email', width: 240, toolTipGetter: true },
  {
    field: 'replacedOn',
    headerName: 'Replaced / Assigned On',
    width: 210,
    valueGetter: ({ value }) => (value ? dayjs(value).format('DD-MM-YYYY hh:mm A') : '—'),
  },
  { field: 'replacementReason', headerName: 'Replacement Reason', width: 280, toolTipGetter: true },
];
